import {
  INSTALL_TRACK_SOURCES,
  type EmTrackProps,
} from "../../analytics/em/events";
import { trackEmEvent } from "../../analytics/em/sdk";
import type { PackageGateDecision } from "./statusClient";

export const ONLINE_PACKAGE_RETIREMENT_GATE_NAME =
  "online_package_retirement_gate";

type RetirementGateAnalyticsProps = Pick<
  PackageGateDecision,
  "sourceKey" | "revision" | "decisionSource" | "reason"
> & {
  installLinkAvailable?: boolean;
};

const buildGateProps = (
  input: RetirementGateAnalyticsProps,
  extra: EmTrackProps = {},
): EmTrackProps => ({
  source: INSTALL_TRACK_SOURCES.ONLINE_PACKAGE_RETIREMENT_GATE,
  entryName: ONLINE_PACKAGE_RETIREMENT_GATE_NAME,
  sourceKey: input.sourceKey,
  revision: input.revision,
  decisionSource: input.decisionSource,
  reason: input.reason,
  installLinkAvailable: input.installLinkAvailable,
  ...extra,
});

export const trackOnlinePackageRetirementDecision = (
  decision: PackageGateDecision,
): void => {
  if (!decision.sourceKey) return;

  trackEmEvent(
    "online_package_retirement_gate_decision",
    buildGateProps(decision, { mode: decision.mode }),
  );
};

export const trackOnlinePackageRetirementView = (
  input: RetirementGateAnalyticsProps,
): void => {
  const props = buildGateProps(input);

  trackEmEvent("online_package_retirement_gate_view", props);
  // Backward compatibility for dashboards created with the initial event name.
  trackEmEvent("package_force_gate_view", props);
};

export const trackOnlinePackageRetirementDownloadClick = (
  input: RetirementGateAnalyticsProps,
): void => {
  const props = buildGateProps(input);

  trackEmEvent("online_package_retirement_gate_download_click", props);
  // Backward compatibility for dashboards created with the initial event name.
  trackEmEvent("package_force_gate_download_click", props);
};
